/**
 * Route construction.
 *
 * Flat and boring on purpose. An earlier build namespaced every route under a design
 * variant so two visual directions could run side by side for comparison; that decision is
 * made, so the prefix is gone and `/picks` is just `/picks`.
 */
export const paths = {
  root: '/',
  login: '/login',
  register: '/register',
  forgot: '/forgot-password',
  reset: '/reset-password',
  join: (code: string) => `/join/${code}`,
  picks: '/picks',
  picksForWeek: (weekId: string) => `/picks/${weekId}`,
  standings: '/standings',
  results: '/results',
  history: '/history',
  settings: '/settings',
  // In the navigation only for members the commissioner has granted it to. Everyone else
  // has no tab, no link, and is refused by the server if they type the path.
  roster: '/roster',
  commish: '/commish',
  commishSlate: '/commish/slate',
  // Both schedule-browser links carry the week being edited. Without it the browser has
  // to guess from the commissioner's default week, which can differ from the one on
  // screen — and adding a game to the wrong week is silent and annoying to undo.
  commishReplace: (slateGameId: string, weekId?: string) =>
    `/commish/slate/${slateGameId}/replace${weekId ? `?week=${weekId}` : ''}`,
  commishAdd: (weekId?: string) => `/commish/slate/add${weekId ? `?week=${weekId}` : ''}`,
  commishResults: '/commish/results',
  commishMembers: '/commish/members',
  commishBroadcast: '/commish/broadcast',
  // Short and opaque. This is the address that ends up on a lock screen, and the slug is
  // the only thing keeping the page private, so there is nothing to gain from a longer
  // prefix that describes what it is.
  broadcastLanding: (slug: string) => `/x/${slug}`,
} as const;
